import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import { db } from '../lib/db';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiKey, FiArrowRight } = FiIcons;

const EditRouter = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const codeParam = searchParams.get('code');
    if (codeParam) {
      setCode(codeParam);
    }
  }, [searchParams]);

  const handleContinue = async () => {
    if (!code.trim()) {
      setError("Please enter your edit code.");
      return;
    }
    
    setIsLoading(true);
    try {
      const record = await db.findByEditCode(code.trim());
      
      if (!record) {
        setError("Invalid code. Please check and try again.");
      } else {
        navigate('/edit-setup', { state: { ...record } });
      }
    } catch (err) {
      setError("Connection error.");
    }
    setIsLoading(false);
  };

  return (
    <Layout>
      <div className="max-w-sm mx-auto space-y-8 py-8">
        <div className="text-center space-y-2">
          <div className="w-16 h-16 bg-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-xl shadow-red-900/20 transform -rotate-6">
            <SafeIcon icon={FiKey} className="text-3xl text-white" />
          </div>
          <h1 className="text-3xl font-bold">Edit your Card</h1>
          <p className="text-zinc-400">Enter the 6-digit code printed on your card or generated during setup.</p>
        </div>

        <div className="space-y-6 bg-zinc-900/50 p-6 rounded-2xl border border-zinc-800">
          <Input 
            label="Edit Code" 
            placeholder="e.g. 483920" 
            value={code} 
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, '').slice(0, 6);
              setCode(val);
              setError('');
            }}
            error={error}
            maxLength={6}
            className="text-center tracking-[0.5em] font-mono text-lg"
          />
          <Button onClick={handleContinue} disabled={isLoading}>
            {isLoading ? "Verifying..." : "Continue"} <SafeIcon icon={FiArrowRight} />
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default EditRouter;